export default "__VITE_ASSET__DG2JuXfy__"